<template>
  <v-container fluid>
    <v-dialog v-model="preloader" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <template>
      <v-card>
        <v-card-title>
          <h2>
            <v-btn
              depressed
              class="mx-2"
              fab
              small
              :to="{ name: 'licenca-list', path: 'lista' }"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <template>
              <span v-if="tituloNovo">Novo Cadastro</span>
              <span v-else>Alterar Cadastro</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-text-field
              v-model="codigo"
              :error-messages="codigoErrors"
              :counter="10"
              label="Código"
              required
              @input="$v.codigo.$touch()"
              @blur="$v.codigo.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="descricao"
              :error-messages="descricaoErrors"
              :counter="50"
              label="Descrição"
              required
              @input="$v.descricao.$touch()"
              @blur="$v.descricao.$touch()"
            ></v-text-field>
            <v-autocomplete
              v-model="select"
              :loading="loading"
              :items="items"
              :search-input.sync="search"
              cache-items
              hide-no-data
              hide-details
              label="Empresa"
              return-object
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    codigo: { required, maxLength: maxLength(10) },
    descricao: { required, maxLength: maxLength(50) }
  },

  data() {
    return {
      id: "",
      descricao: "",
      codigo: "",
      preloader: false,
      tituloNovo: true,

      loading: false,
      search: null,
      select: null
    };
  },

  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.maxLength && errors.push("Somente 50 caracteres.");
      !this.$v.descricao.required && errors.push("Descrição é Obrigatório.");
      return errors;
    },
    codigoErrors() {
      const errors = [];
      if (!this.$v.codigo.$dirty) return errors;
      !this.$v.codigo.maxLength && errors.push("Somente 10 caracteres.");
      //!this.$v.codigo.numeric && errors.push("Somente número");
      !this.$v.codigo.required && errors.push("Agência é Obrigatório.");
      return errors;
    },
    items() {
      return this.$store.state.licenca.empresas;
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    }
  },

  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        //this.loading = true;
        const success = this.$store.dispatch("licenca/gravar", {
          id: this.id,
          descricao: this.descricao,
          codigo: this.codigo,
          id_empresa: this.select
        });
        //this.loading = false;
        if (success) {
          this.$router.replace({ path: "lista", name: "licenca-list" });
        }
      }
    },
    querySelections(v) {
      this.loading = true;
      v;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  },
  async mounted() {
    //this.preloader = true;

    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch("licenca/carregarLicenca", {
          id
        });
        this.descricao = response.data[0].descricao;
        this.codigo = response.data[0].codigo;
        this.select = response.data[0].id_empresa.value;

        //this.preloader = false;
      } catch (err) {
        //deu pau
      }
    }

    // preencher combo grupo item
    try {
      this.$store.dispatch("licenca/carregarEmpresas");

      //this.preloader = false;
    } catch (err) {
      //deu pau
    }
  }
};
</script>
